import React from 'react'
import PropTypes from 'prop-types'
import {
  ContainerActivityBlotterAgGridTable,
  GridWidget,
  TypographyWidgetStyle
} from '../../TradeBlotter.style'
import { Box, Grid } from '@mui/material'
import { ReactComponent as Close } from '../../../../assets/close.svg'
import { AgGridReact } from 'ag-grid-react'
import { CounterPartyTitleStyle } from './WidgetActivityBlotter.style'

const WidgetActivityBlotter = ({
  handleRemoveWidget,
  columnDefs,
  defaultColDef,
  activityBlotterResponse
}) => {
  return (
    <>
      <GridWidget>
        <TypographyWidgetStyle>Activity Blotter</TypographyWidgetStyle>
        <Grid marginTop={'auto'} marginBottom={'auto'}>
          <Close
            style={{ marginRight: '10px', cursor: 'pointer' }}
            onClick={() => handleRemoveWidget('Activity Blotter')}
          />
        </Grid>
      </GridWidget>
      <ContainerActivityBlotterAgGridTable>
        <Grid
          container
          style={{ height: '100%', display: 'flex', justifyContent: 'space-between' }}
        >
          <Grid item xs={6}>
            <CounterPartyTitleStyle>Client</CounterPartyTitleStyle>
            <AgGridReact
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              suppressRowClickSelection={true}
              rowData={activityBlotterResponse.clients}
              rowMultiSelectWithClick={true}
              suppressScrollOnNewData={true}
            />
          </Grid>
          <Grid item xs={6}>
            <CounterPartyTitleStyle>Market Maker</CounterPartyTitleStyle>
            <AgGridReact
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              detailRowAutoHeight={true}
              suppressRowClickSelection={true}
              rowData={activityBlotterResponse.market_makers}
              rowMultiSelectWithClick={true}
              suppressScrollOnNewData={true}
            />
          </Grid>
        </Grid>
      </ContainerActivityBlotterAgGridTable>
      <Box
        style={{
          backgroundColor: '#242428',
          width: '100%',
          paddingTop: '80px',
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px'
        }}
      />
    </>
  )
}

export default WidgetActivityBlotter

WidgetActivityBlotter.propTypes = {
  handleRemoveWidget: PropTypes.func,
  columnDefs: PropTypes.array,
  defaultColDef: PropTypes.object,
  activityBlotterResponse: PropTypes.object
}
